import React from "react"
import {FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import UserIcon from "../../../../../gd-components/icons/user/user";
import {ADD_USER} from "../../user";

// const debug = "FieldUser_Editable"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldUser_Editable extends React.Component<FieldEditableProps, State> {

    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    onMouseEnter = () => {

        if (!this.props.field.canEdit(this.props.model) || this.props.disabled) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onValueChange(value:any, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        if (value === ADD_USER) {
            this.props.onAddClick && this.props.onAddClick()
            return
        }

        this.props.onChange && this.props.onChange(value)
    }

    onClick = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    onOptionClick = (option:Option) => {
        this.onValueChange(option.value)
    }

    onDelete = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        this.onValueChange(null)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderValue() {

        const value = _.get(this.props.model, this.props.field.fieldId, null)

        if (!value) {
            return (
                <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>
                    <div className="max-w-100-percent txt-truncate cursor-default ui5-color-not-important">
                        {this.props.field.placeholder}
                    </div>
                </div>
            )
        }

        const user = gd.session.users.get(value)!

        if (this.props.iconOnly) {
            return (
                <div className={Classes("flex-row-center-center", "w-100-percent")}>
                    <UserIcon className="" userId={user?.id} size="22"/>
                </div>
            )
        }

        return (
            <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>

                <UserIcon className="m-r-5" userId={user.id} size="22"/>
                <div className="max-w-100-percent txt-truncate cursor-default">{user?.name}</div>
            </div>
        )
    }

    renderHovered() {

        const field = this.props.field
        const classes = Classes(this.classes, "is-hovered", {})

        // ui5-field-editable is-hovered w-100-percent h-100-percent

        const value = _.get(this.props.model, this.props.field.fieldId, null)

        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    {this.renderValue()}

                    {!this.props.iconOnly &&
                        <div className="buttons flex-no-shrink">
                            {this.props.field.noValueOption && !!value && <div className="btn-reset" onClick={this.onDelete}/>}
                            <div className="btn-arrow"/>
                        </div>
                    }

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.model} />
                    }

                </div>
            </React.Fragment>
        )
    }

    renderNotHovered() {

        // const userId    = _.get(this.props.model, this.props.field.fieldId, null)
        // const user      = userId ? gd.session.users.get(userId) : null

        return (
            <React.Fragment>
                <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    {this.renderValue()}

                </div>
            </React.Fragment>
        )

    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered, this.props)


        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()

    }

}



